export default __webpack_public_path__ + "static/media/spotifyArtistSearch.5bf1deb8.png";